module.exports = __webpack_public_path__ + "media/images/workplace/patterns/8-15e1b1a420005094054fe185a7b815c4.png";